module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_03-9172e36e117fcca73487d0b8b994429c.svg";